module.exports = __webpack_public_path__ + "static/img/lucky.ab05b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gameHome/lucky.png
// module id = izBl
// module chunks = 52